import { createUseQuery } from 'api/common/createUseQuery'
import { fetchSkillById } from 'api/fetchers/marketing-capabilities/skills/fetchSkillById'
import { ApiQueryKeys } from 'constants/apiQueryKeys'
import { Skill } from 'pages/exploreLearnings/components/SkillTag'

interface SkillDetails {
  name: string
  description: string
  iconUrl: string
  backgroundUrl: string
  practitioners: Practitioner[]
  resourcesCategories: ResourceCategory[]
  skillsPickedForYou: Skill[]
}

interface ResourceCategory {
  category: string
  resources: Array<{
    id: string
    name: string
    url: string
    description: string
    skills: Skill[]
    readTime: string
  }>
}

interface Practitioner {
  email: string
  id: string
  jobPosition: string
  location: string
  name: string
  photoUrl: string
  skills: Skill[]
  surname: string
}

export const useSkillById = createUseQuery({
  queryKey: ApiQueryKeys.SKILLS_BY_ID,
  fetcher: fetchSkillById,
  selector: res => res?.data ?? ({} as SkillDetails),
})
